import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/open-pages/testing-numbers.css";
import HelmetWrapper from "../../HelmetWrapper";
import { fetchTestingNumbersData } from "../../redux/plans-reducers/plansSlice";
import CommonStructured from "../../components/common-components/CommonStructured";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";

const TestingNumbers = () => {
  const dispatch = useDispatch();
  const { testingNumbers, testingNumbersLoading, testingNumbersError } =
    useSelector((state) => state.plans);

  const [allNumbers, setAllNumbers] = useState([]);

  function getTestingNumbers(filters) {
    dispatch(
      fetchTestingNumbersData({
        filters: filters,
        token: "nFMjOROg5xdWVt1gG0wAcWdEd",
      })
    );
  }

  useEffect(() => {
    getTestingNumbers({});
  }, []);

  useEffect(() => {
    if (
      !testingNumbersLoading &&
      !testingNumbersError &&
      testingNumbers?.status
    ) {
      setAllNumbers(testingNumbers?.data);
    } else {
      setAllNumbers([]);
    }
  }, [testingNumbers, testingNumbersLoading, testingNumbersError]);

  return (
    <HelmetWrapper title="WTF: Testing Numbers">
      <Container className="bg-cloud-k px-50px py-50px gobal-container" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Testing Numbers and Status"}
              isReload={() => {
                getTestingNumbers({});
              }}
            />

            {testingNumbersLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <div className="testing-cards">
                {allNumbers.map((test, index) => (
                  <div
                    key={index}
                    className={`testing-card ${
                      test.status === "active" ? "active-card" : "inactive-card"
                    }`}
                  >
                    <div className="phone-number">{test.mobile}</div>
                    <div
                      className={`status ${
                        test.status === "active"
                          ? "active-status"
                          : "inactive-status"
                      }`}
                    >
                      {test.status}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default TestingNumbers;
